var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowCounterclockwise = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.001,
    height: 14,
    viewBox: "0 0 12.001 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-counterclockwise",
    transform: "translate(-1.999 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M12.83,6.706a5,5,0,0,0-7.1-3.16.5.5,0,1,1-.454-.892A6,6,0,1,1,2.545,5.5a.5.5,0,0,1,.91.417,5,5,0,1,0,9.375.789Z",
    fill: "#126cfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M7.854.146a.5.5,0,0,0-.708,0l-2.5,2.5a.5.5,0,0,0,0,.708l2.5,2.5a.5.5,0,0,0,.708-.708L5.707,3,7.854.854a.5.5,0,0,0,0-.708Z",
    fill: "#126cfc"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowCounterclockwise);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMi4wMDEiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxMi4wMDEgMTQiPgogIDxnIGlkPSJhcnJvdy1jb3VudGVyY2xvY2t3aXNlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMS45OTkgMC4wMDEpIj4KICAgIDxwYXRoIGlkPSJQYXRoXzEwMyIgZGF0YS1uYW1lPSJQYXRoIDEwMyIgZD0iTTEyLjgzLDYuNzA2YTUsNSwwLDAsMC03LjEtMy4xNi41LjUsMCwxLDEtLjQ1NC0uODkyQTYsNiwwLDEsMSwyLjU0NSw1LjVhLjUuNSwwLDAsMSwuOTEuNDE3LDUsNSwwLDEsMCw5LjM3NS43ODlaIiBmaWxsPSIjMTI2Y2ZjIi8+CiAgICA8cGF0aCBpZD0iUGF0aF8xMDQiIGRhdGEtbmFtZT0iUGF0aCAxMDQiIGQ9Ik03Ljg1NC4xNDZhLjUuNSwwLDAsMC0uNzA4LDBsLTIuNSwyLjVhLjUuNSwwLDAsMCwwLC43MDhsMi41LDIuNWEuNS41LDAsMCwwLC43MDgtLjcwOEw1LjcwNywzLDcuODU0Ljg1NGEuNS41LDAsMCwwLDAtLjcwOFoiIGZpbGw9IiMxMjZjZmMiLz4KICA8L2c+Cjwvc3ZnPgo=";